import React from 'react';

const UserSessions = () => {
  return <h2>User Sessions Management Page</h2>;
};

export default UserSessions;
